import LoginForm from 'components/Login';
import React from "react"
const Login = () => {
  return <LoginForm />;
};
export default Login;
